// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__18ftK","file":"styles_file__1dOeD"};